import React, { useMemo, useState } from "react";
import { MoneyExP2POrders } from "../../../pages";
import { MoneyExController } from "../../../controllers";
import { encodeQueryData } from "../../../utils/utils";

const MoneyExP2POrdersContainer = () => {
  const modalConstants = {
    Close: "CLOSE",
    ViewMoreInfo: "View More Info",
    VerifyBuyerPayment: "Verify Buyer Payment",
    VerifySellerPayment: "Verify Seller Payment",
    UpdateBuyerPayment: "Update Buyer Payment",
    UpdateSellerPayment: "Update Seller Payment",
    RefundBuyerPayment: "Refund Buyer Payment",
  };

  const [limit, setLimit] = useState(50);
  // const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [openModal, setOpenModal] = useState(modalConstants.Close);
  const [singleItem, setsingleItem] = useState({});

  const openModalHandler = (item) => {
    setOpenModal(item);
  };
  const closeModal = () => {
    setOpenModal(modalConstants.Close);
  };

  const options = (
    buyerStatus,
    sellerStatus,
    adminBuyerPaymentStatus,
    adminSellerPaymentStatus,
    status
  ) => {
    const options = [
      {
        label: modalConstants.ViewMoreInfo,
        value: modalConstants.ViewMoreInfo,
      },
    ];

    if (status !== "FAILED") {
      if (buyerStatus !== "PAID" && buyerStatus !== "REVERSED") {
        options.push({
          label: modalConstants.VerifyBuyerPayment,
          value: modalConstants.VerifyBuyerPayment,
        });
      }

      if (
        buyerStatus === "PAID" &&
        sellerStatus !== "PAID" &&
        sellerStatus !== "FALSE-PAYMENT"
      ) {
        options.push({
          label: modalConstants.VerifySellerPayment,
          value: modalConstants.VerifySellerPayment,
        });
      }

      if (
        buyerStatus === "PAID" &&
        sellerStatus === "PAID" &&
        adminBuyerPaymentStatus === "AWAITING"
      ) {
        options.push({
          label: modalConstants.UpdateBuyerPayment,
          value: modalConstants.UpdateBuyerPayment,
        });
      }

      if (
        adminBuyerPaymentStatus === "PAID" &&
        adminSellerPaymentStatus === "AWAITING"
      ) {
        options.push({
          label: modalConstants.UpdateSellerPayment,
          value: modalConstants.UpdateSellerPayment,
        });
      }
      if (status !== "COMPLETED" && buyerStatus !== "REVERSED") {
        options.push({
          label: modalConstants.RefundBuyerPayment,
          value: modalConstants.RefundBuyerPayment,
        });
      }
    }

    return options;
  };

  const optionHandler = (option, item) => {
    setsingleItem(item);
    openModalHandler(option.value);
  };

  const query = useMemo(() => {
    return {
      ...(searchQuery ? { search: searchQuery } : {}),
      limit: limit,
      offset: currentPage,
    };
  }, [searchQuery, limit, currentPage]);

  const encodeP2PQuery = encodeQueryData({
    ...query,
  });

  const { isLoading, data, isFetching, refetch } =
    MoneyExController.useGetP2POrders(encodeP2PQuery);

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  return (
    <MoneyExP2POrders
      onLimitChange={onLimitChange}
      data={data}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      limit={limit}
      isLoading={isLoading}
      isFetching={isFetching}
      setSearchQuery={setSearchQuery}
      openModal={openModal}
      optionHandler={optionHandler}
      closeModal={closeModal}
      modalConstants={modalConstants}
      singleItem={singleItem}
      options={options}
      refetch={refetch}
    />
  );
};

export default MoneyExP2POrdersContainer;
